import { styled } from '@vw-marketing/us-components';

export const StyledAppContainer = styled.div`
  > div {
    display: flex;
    justify-content: center;
  }
`;

